/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EStatusFilterType, EVehicleStatusType } from '../../models';

export interface IMapOptionsState {
  isSuggestedGeofencesEnabled: boolean;
  isGeofencesEnabled: boolean;
  isGarminStopsEnabled: boolean;
  isWorkOrdersEnabled: boolean;
  isShowLabelsEnabled: boolean;
  isShowTachoInformationEnabled: boolean;
  vehicleStatusFilterType: EStatusFilterType;
  isMapOptionsOpened: boolean;
  isShowVehicleBalloonLinksEnabled: boolean;
}

export const initialMapOptionsState: IMapOptionsState = {
  isSuggestedGeofencesEnabled: false,
  isGeofencesEnabled: false,
  isGarminStopsEnabled: false,
  isWorkOrdersEnabled: false,
  isShowLabelsEnabled: false,
  isShowTachoInformationEnabled: false,
  vehicleStatusFilterType: EVehicleStatusType.All,
  isMapOptionsOpened: false,
  isShowVehicleBalloonLinksEnabled: true
};
